import React, { useState } from 'react'

import { useAuth, useProtectedPage } from '../../../../context/AuthContext'
import Loading from '../../../../templates/UI/Loading/Loading'
import Applications from '../Applications/Applications'
import ComplianceFollowups from '../ComplianceFollowups/ComplianceFollowups'
import ComplianceTeam from '../ComplianceTeam/ComplianceTeam'
import FraudPulls from '../FraudPulls/FraudPulls'
import FraudReport from '../FraudReport/FraudReport'
import FraudWatchAffiliates from '../FraudWatchAffiliates/FraudWatchAffiliates'
import FraudWatchCampaigns from '../FraudWatchCampaigns/FraudWatchCampaigns'
import HighMediumUnderJr from '../HighMediumUnderJr/HighMediumUnderJr'
import NewestAffiliates from '../NewestAffiliates/NewestAffiliates'
import PendingFirstPayment from '../PendingFirstPayment/PendingFirstPayment'
import QualityCheckAffiliates from '../QualityCheckAffiliates/QualityCheckAffiliates'
import RejectedAppsToReview from '../RejectedAppsToReview/RejectedAppsToReview'
import ReversalRequestsDashboard from '../ReversalRequests/ReversalRequestsDashboard'

export default function ComplianceDirector({ manager, showSystemMessage }) {
    const auth = useAuth()
    useProtectedPage(auth.permissions, 'compliance_director_dashboard')

    const [dataLoaded, setDataLoaded] = useState(true)

    return (
        <React.Fragment>
            {dataLoaded ? (
                <React.Fragment>
                    <div className="page-header d-flex align-items-center">
                        <h1 className="mb-h1">Compliance Director</h1>
                    </div>
                    <div className="row">
                        <div className="col-lg-4">
                            <ComplianceFollowups manager={manager} />
                            <ComplianceFollowups manager={manager} mode="team" />
                            <ComplianceFollowups manager={manager} mode="unassigned" />
                            <Applications manager={manager} showSystemMessage={showSystemMessage} mode="compliance" />
                            <RejectedAppsToReview manager={manager} />
                        </div>
                        <div className="col-lg-8">
                            <ComplianceTeam showSystemMessage={showSystemMessage} mode="team" />
                            <FraudReport manager={manager} />
                            <div className="row">
                                <div className="col-lg-6">
                                    <PendingFirstPayment />
                                    <FraudWatchCampaigns manager={manager} showSystemMessage={showSystemMessage} />
                                    <FraudWatchAffiliates manager={manager} showSystemMessage={showSystemMessage} />
                                    <QualityCheckAffiliates manager={manager} />
                                    <FraudPulls showSystemMessage={showSystemMessage} />
                                </div>
                                <div className="col-lg-6">
                                    <ReversalRequestsDashboard status="C" />
                                    <HighMediumUnderJr manager={manager} />
                                    <NewestAffiliates manager={manager} showSystemMessage={showSystemMessage} />
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            ) : (
                <Loading></Loading>
            )}
        </React.Fragment>
    )
}
